import { DatasetRowId } from '@discngine/moosa-models';

export const keyToColorIndex = (key: DatasetRowId) => {
  return parseInt(key.substr(0, 7) + key.substr(18), 16);
};
